import { Request } from '../utils';
import { cancelTokenSource } from 'app/utils/axios';

const prefix = 'system_user';

// GET System User List
export const getSystemUserList = queries => {
  const { limit, skip, orderBy, sortBy, name, surname } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!surname && params.append('surname', surname);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

// GET System User Detail
export const getSystemUserDetail = id => {
  return Request.get(`${prefix}/${id}`, { onlyError: true });
};

// POST Add System User
export const addSystemUser = values => {
  return Request.post(`${prefix}`, values, { handleNotification: true });
};

// PUT Update System User
export const updateSystemUser = (id, values) => {
  return Request.put(`${prefix}/${id}`, values, {
    cancelToken: cancelTokenSource.token,
    handleNotification: true
  });
};

// PUT Update System User Password
export const updateSystemUserPwd = (userId, values) => {
  return Request.put(`${prefix}/${userId}/password`, values, { handleNotification: true });
};

// PUT Update Role
export const updateUserRole = (id, values) => {
  return Request.put(`${prefix}/${id}/role`, values, { handleNotification: true });
};

// DELETE System User
export const deleteSystemUser = id => {
  return Request.delete(`${prefix}/${id}`, { handleNotification: true });
};

// DELETE User Photo
export const deleteUserPhoto = id => {
  return Request.delete(`${prefix}/${id}/photo`, { onlyError: true });
};
